import { BooleanInput, SearchInput } from 'react-admin'

const SchoolYearListFilter = [
    <SearchInput variant="outlined" placeholder="Search name" source="name" alwaysOn />,
    <BooleanInput source="active" label="Published" variant="outlined" defaultValue={true} />
]

export default SchoolYearListFilter
